import Main from '@/views/administracion/configuracion/catalogos/clientes/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/clientes/Default.vue';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const clientes = [
  {
    path: 'clientes',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoClientes',
        path: '/',
        meta: {
          title: 'Clientes',
          auth,
          scopes,
        },
        component: Default,
      },
    ],
  },
];

export default clientes;
